<template>
  <div class="model-3D relative">
    <!-- <div class="controls">
      <button @click="getCameraPostion">Get Camera Position</button>
    </div> -->
    <!-- 开关 -->
    <div class="btn-main">
      <!-- <div>{{ $t("Data Streaming") }}</div> -->
      <div
        :class="['btn-showData', !iconStatus && 'runstart']"
        @click="showPenalData()"
      >
        <div class="btn-stop" v-show="iconStatus">
          <img src="@/assets/stop.png" alt="" />
        </div>
        <div class="btn-start" v-show="!iconStatus">
          <img src="@/assets/start.png" alt="" />
        </div>
      </div>
    </div>
    <div class="scene relative" id="webgl"></div>
    <div id="penal" v-show="showPoint"></div>
    <!-- 测点 -->
    <!-- 螺杆泵 -->
    <div id="point-lgb" v-show="lgb_status">
      <div class="circle"></div>
      <div class="inner-roll">
        <img
          src="@/assets/icon-inner-roll.png"
          alt=""
          :class="[lgb_status && 'roll-img']"
        />
      </div>
      <div class="outer-roll">
        <img
          src="@/assets/icon-outer-roll.png"
          alt=""
          :class="[lgb_status && 'roll-img']"
        />
      </div>
    </div>
    <!-- 螺杆泵电机 -->
    <div id="point-lgbdj" v-show="lgbdj_status">
      <div class="circle"></div>
      <div class="inner-roll">
        <img
          src="@/assets/icon-inner-roll.png"
          alt=""
          :class="[lgbdj_status && 'roll-img']"
        />
      </div>
      <div class="outer-roll">
        <img
          src="@/assets/icon-outer-roll.png"
          alt=""
          :class="[lgbdj_status && 'roll-img']"
        />
      </div>
    </div>
    <!-- 罗茨泵电机 -->
    <div id="point-lcbdj" v-show="lcbdj_status">
      <div class="circle"></div>
      <div class="inner-roll">
        <img
          src="@/assets/icon-inner-roll.png"
          alt=""
          :class="[lcbdj_status && 'roll-img']"
        />
      </div>
      <div class="outer-roll">
        <img
          src="@/assets/icon-outer-roll.png"
          alt=""
          :class="[lcbdj_status && 'roll-img']"
        />
      </div>
    </div>
    <!-- 数据 -->
    <div class="data-main">
      <!-- 系统信息 -->
      <div class="sys">
        <div v-for="(data, index) in lcb_data" :key="index" class="data">
          <div class="data-lable">
            <span>{{ data.lable }}</span>
            <span>{{ data.unit }}</span>
          </div>
          <div class="data-value">
            {{ data.value }}
          </div>
        </div>
      </div>
      <!-- 罗茨泵电机 -->
      <div class="lcbdj">
        <div class="data-head">{{ $t("Roots pump motor") }}</div>
        <div class="data-body">
          <div v-for="(data, index) in lcbdj_data" :key="index" class="data">
            <div class="data-lable">
              <span>{{ data.lable }}</span>
              <span>{{ data.unit }}</span>
            </div>
            <div class="data-value">{{ lcbdj_value ? data.value : "" }}</div>
          </div>
        </div>
      </div>
      <!-- 螺杆泵 -->
      <div class="lgb">
        <div class="data-head">{{ $t("Screw pumps") }}</div>
        <div class="data-body">
          <div v-for="(data, index) in lgb_data" :key="index" class="data">
            <div class="data-lable">
              <span>{{ data.lable }}</span>
              <span>{{ data.unit }}</span>
            </div>
            <div class="data-value">{{ lgb_value ? data.value : "" }}</div>
          </div>
        </div>
      </div>
      <!-- 螺杆泵电机 -->
      <div class="lgbdj">
        <div class="data-head">{{ $t("Screw pump motor") }}</div>
        <div class="data-body">
          <div v-for="(data, index) in lgbdj_data" :key="index" class="data">
            <div class="data-lable">
              <span>{{ data.lable }}</span>
              <span>{{ data.unit }}</span>
            </div>
            <div class="data-value">{{ lgbdj_value ? data.value : "" }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from "three";
import GLTFLoader from "three-gltf-loader";
const OrbitControls = require("three-orbitcontrols");
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import {
  CSS2DRenderer,
  CSS2DObject
} from "three/examples/jsm/renderers/CSS2DRenderer.js";

let renderer,
  controls,
  scene,
  camera,
  css2DRenderer,
  ambientLight,
  pointLight1,
  pointLight2;

export default {
  name: "VSD420-F-Model",
  data() {
    return {
      showPoint: false,
      iconStatus: true,
      penalObject: [],
      lcbdj_status: false,
      lcbdj_value: false,
      lgb_status: false,
      lgb_value: false,
      lgbdj_status: false,
      lgbdj_value: false,
      timer1: null,
      timer2: null,
      timer3: null
    };
  },
  props: {
    modelList: {
      /* 模型 */
      type: Array,
      default: null,
      required: true
    }
  },
  computed: {
    lcb_data() {
      return [
        {
          lable: this.$t("Inlet temperature-sim"),
          unit: "(°C)",
          value: "10"
        },
        {
          lable: this.$t("Inlet Flow-sim"),
          unit: "(m3/h)",
          value: "(1090, 1110)"
        },
        {
          lable: this.$t("Inlet Pressure"),
          unit: "(mbarA)",
          value: "2"
        },
        {
          lable: this.$t("Outlet Pressure"),
          unit: "(mbarA)",
          value: "1013"
        }
      ];
    },
    lcbdj_data() {
      return [
        {
          lable: this.$t("Rotation Speed"),
          unit: "(rpm)",
          value: "(2345, 2355)"
        },
        {
          lable: this.$t("Current"),
          unit: "(A)",
          value: "(5.82, 6.31)"
        },
        {
          lable: this.$t("X-axis Vibration"),
          unit: "(mm/s)",
          value: "(3.2, 4.32)"
        }
      ];
    },
    lgb_data() {
      return [
        {
          lable: this.$t("Inlet traffic"),
          unit: "(m3/h)",
          value: "(285, 312)"
        },
        {
          lable: this.$t("Inlet pressure"),
          unit: "(mbarA)",
          value: "(8.9, 9.1)"
        }
      ];
    },
    lgbdj_data() {
      return [
        {
          lable: this.$t("Rotation Speed"),
          unit: "(rpm)",
          value: "(2945, 2955)"
        },
        {
          lable: this.$t("Current"),
          unit: "(A)",
          value: "(21, 22)"
        },
        {
          lable: this.$t("X-axis Vibration"),
          unit: "(mm/s)",
          value: "(2.8, 3.91)"
        }
      ];
    },
    faultList() {
      return {
        warning: this.$t("Pump Stuck Caution"),
        error: this.$t("Pump Stuck Warning")
      };
    }
  },
  components: {},
  mounted() {
    this.init();
  },
  methods: {
    showPenalData() {
      clearTimeout(this.timer1);
      clearTimeout(this.timer2);
      clearTimeout(this.timer3);
      this.showPoint = !this.showPoint;
      this.iconStatus = !this.iconStatus;
      if (!this.iconStatus) {
        /* 罗茨泵电机开始 */
        this.lcbdj_status = true;
        this.timer1 = setTimeout(() => {
          this.lcbdj_status = false;
          this.lcbdj_value = true;
          this.lgb_status = true;
        }, 2000);
        /* 螺杆泵开始 */
        this.timer2 = setTimeout(() => {
          this.lgb_status = false;
          this.lgb_value = true;
          this.lgbdj_status = true;
        }, 4000);
        /* 螺杆泵电机开始 */
        this.timer3 = setTimeout(() => {
          this.lgbdj_status = false;
          this.lgbdj_value = true;
        }, 6000);
      } else {
        this.lcbdj_status = false;
        this.lcbdj_value = false;
        this.lgb_status = false;
        this.lgb_value = false;
        this.lgbdj_status = false;
        this.lgbdj_value = false;
      }
    },
    getCameraPostion() {
      alert(JSON.stringify(camera.position));
    },
    createMarker(id, { x, y, z }) {
      let domObject = new CSS2DObject(document.getElementById(id));
      domObject.position.x = x;
      domObject.position.y = y;
      domObject.position.z = z;
      return domObject;
    },
    createLine(
      position1 = { x: 0, y: 0, z: 0 },
      position2 = { x: 0, y: 0, z: 0 }
    ) {
      let geometry = new THREE.Geometry();
      let lineMaterial = new THREE.LineBasicMaterial({
        color: "#01E7FF"
      });
      geometry.vertices.push(
        new THREE.Vector3(position1.x, position1.y, position1.z),
        new THREE.Vector3(position2.x, position2.y, position2.z)
      );
      let line = new THREE.Line(geometry, lineMaterial);
      scene.add(line);
    },
    /* 清空模型 */
    clearModel() {
      if (scene && scene.children.length >= 1) {
        scene.children.map(item => {
          scene.remove(item);
        });
        scene.children = [];
        let domDiv = document.querySelector("#webgl");
        if (domDiv != null) {
          domDiv.innerHTML = "";
        }
        camera = null;
        controls = null;
        scene = null;
        renderer.dispose();
        renderer = null;
      }
    },
    init() {
      document.querySelector("#webgl").innerHTML = "";
      this.clearModel();

      /* 场景 */
      scene = new THREE.Scene();
      scene.scale.set(0.5, 0.5, 0.5);
      scene.position.set(-10, 10, -80);
      /* 相机设置 */
      camera = new THREE.PerspectiveCamera(
        75,
        window.innerWidth / window.innerHeight,
        1,
        2000
      );
      camera.position.set(-122, 1.7, 33);
      camera.lookAt(new THREE.Vector3(0, 0, 0));

      /* 模型加载 */
      var loader = new GLTFLoader();
      DRACOLoader.setDecoderPath("/static/draco/gltf/");
      DRACOLoader.setDecoderConfig({ type: "js" });

      loader.setDRACOLoader(new DRACOLoader());

      this.modelList.map((item) => {
        loader.load(
          item,
          gltf => {
            // console.log(gltf.scene);
            let model = gltf.scene;
            gltf.scene.traverse(object => {
              if (object.isMesh) {
                object.material.emissiveMap = object.material.map;
              }

              /* 测点位置 */
              if (object.name == "罗茨泵电机球") {
                let point_lcbdj = this.createMarker(
                  "point-lcbdj",
                  object.position
                );
                scene.add(point_lcbdj);
              }
              if (object.name == "螺杆泵球") {
                let point_lgb = this.createMarker("point-lgb", object.position);
                scene.add(point_lgb);
              }
              if (object.name == "螺杆泵电机球") {
                let point_lgbdj = this.createMarker(
                  "point-lgbdj",
                  object.position
                );
                scene.add(point_lgbdj);
              }
            });
            mixer = new THREE.AnimationMixer(gltf.scene);

            if (gltf.animations.length) {
              let animationAction = mixer.clipAction(gltf.animations[0]).play();
              animationActions.push(animationAction);
            }

            scene.add(model);
          },
          evt => {
            console.log(evt);
          },
          function(error) {
            console.error(error);
          }
        );
      });

      /* css渲染器 */
      css2DRenderer = new CSS2DRenderer();
      css2DRenderer.setSize(
        document.querySelector("#webgl").offsetWidth,
        document.querySelector("#webgl").offsetHeight
      );
      css2DRenderer.domElement.style.position = "absolute";
      css2DRenderer.domElement.style.top = "0";
      document.getElementById("penal").appendChild(css2DRenderer.domElement);

      /* 渲染器 */
      renderer = new THREE.WebGLRenderer({ alpha: true });
      this.$nextTick(() => {
        renderer.setSize(
          document.querySelector("#webgl").offsetWidth,
          document.querySelector("#webgl").offsetHeight
        );
      });
      renderer.setClearColor(0xffffff, 0);
      renderer.setPixelRatio(window.devicePixelRatio);
      document.getElementById("webgl").appendChild(renderer.domElement);

      let clock = new THREE.Clock();

      let mesh;
      let mixer = new THREE.AnimationMixer(mesh);
      let animationActions = [];

      //控制器
      controls = new OrbitControls(
        camera,
        document.getElementById("webgl"),
        renderer.domElement
      );
      /* 缩放 */
      controls.enableZoom = false;
      controls.enablePan = false;
      /* 旋转 */
      controls.enableRotate = false;
      // controls.autoRotate = true;
      // controls.autoRotateSpeed = 0.5;
      /* 阻尼系数 */
      // controls.enableDamping = true;
      // controls.dampingFactor = 0.1;
      //限制垂直方向的旋转
      // controls.minPolarAngle = Math.PI * 0.38;
      // controls.maxPolarAngle = Math.PI * 0.38;

      //light
      this.setLight();

      const animate = () => {
        controls.update();
        var delta = clock.getDelta();
        if (mixer != null) {
          mixer.update(delta);
        }

        renderer.render(scene, camera);

        css2DRenderer.render(scene, camera);

        requestAnimationFrame(animate);
      };

      animate();
    },
    /* 全景灯光 */
    setLight() {
      ambientLight = new THREE.AmbientLight(0xffffff, 1);
      ambientLight.position.set(0, 100, 0);

      pointLight1 = new THREE.PointLight(0xffffff, 0.8);
      pointLight1.position.set(-2616, 1719, 1502);

      pointLight2 = new THREE.PointLight(0xffffff, 0.8);
      pointLight2.position.set(202, 202, -232);

      scene.add(ambientLight, pointLight1, pointLight2);
    }
  }
};
</script>


<style scoped lang="scss">
.model-3D {
  width: 100%;
  height: 100%;
  .scene {
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  .controls {
    position: absolute;
    top: 0%;
    left: 50%;
    z-index: 100;
  }

  #penal {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .btn-main {
    position: absolute;
    top: 2%;
    left: 1%;
    z-index: 100;
    display: flex;
    flex-flow: column;
    align-items: center;
    font-size: 18px;
    .btn-showData {
      margin-top: 5px;
      border: 3px solid #00e7ff;
      filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
      border-radius: 30px;
      padding: 5px 8px;
      display: flex;
      align-items: center;
      width: 82px;
      &:hover {
        cursor: pointer;
      }
      .btn-stop {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        background: #02364b;
        border-radius: 50%;
        padding: 6px;
        margin-right: 20px;
      }
      .btn-start {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        background: #02364b;
        border-radius: 50%;
        padding: 6px;
      }
      &.runstart {
        justify-content: flex-end;
        background: #00e7ff;
      }
    }
  }

  .data-main {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 98;
    width: 100%;
    height: 100%;

    .sys {
      display: flex;
      flex-wrap: wrap;
      position: absolute;
      width: 70%;
      top: 2%;
      left: 50%;
      transform: translateX(-50%);
      .data {
        flex: 1;
        margin-right: 20px;

        &:nth-last-child(1) {
          margin-right: 0;
        }
        .data-lable {
          font-size: 26px;
          margin-bottom: 10px;
        }
        .data-value {
          min-width: 30%;
          min-height: 30px;
          font-size: 20px;
          color: #7cffb2;
          // border-bottom: 2px solid #7cffb2;
        }
      }
    }

    .lcbdj,
    .lgb,
    .lgbdj {
      width: 40%;
      position: absolute;
      background: url("../../../assets/数据框.png") no-repeat;
      background-size: 100% 100%;

      &.lcbdj {
        top: 18%;
        right: 5%;
      }
      &.lgb {
        top: 40%;
        right: 5%;
      }
      &.lgbdj {
        top: 64%;
        right: 5%;
      }

      .data-head {
        background: linear-gradient(90deg, #00618b 0.26%, #00aeb8 100%);
        padding: 10px 20px;
        margin: 1.5px 1.5px 0;
        border-top-left-radius: 10px;
        font-size: 26px;
      }
      .data-body {
        background: rgba(4, 255, 255, 0.1);
        padding: 10px 20px;
        display: flex;
        border-bottom-right-radius: 32px;
        font-size: 20px;
        .data {
          margin: 10px 0;
          flex: 1;
          .data-lable {
            margin-bottom: 10px;
          }
          .data-value {
            min-width: 30%;
            min-height: 30px;
            color: #00ffff;
            // border-bottom: 2px solid #00ffff;
          }
        }
      }
    }
  }

  #point-lgbdj,
  #point-lcbdj,
  #point-lgb {
    width: 60px;
    top: 0rem;
    left: 0rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .circle {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #04ffff;
  }
  .inner-roll {
    position: absolute;
    width: 50%;
    .roll-img {
      animation: roll-left 1.2s linear infinite;
    }
  }
  .outer-roll {
    width: 100%;
    position: absolute;
    .roll-img {
      animation: roll-right 1.2s linear infinite;
    }
  }

  @keyframes roll-right {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes roll-left {
    0% {
      transform: rotate(360deg);
    }

    100% {
      transform: rotate(0deg);
    }
  }
}
</style>
